// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-customer-settings-preview-panel .mat-mdc-dialog-content {
  max-height: 90vh;
  padding: 0;
}

.fi-customer-settings-preview {
  display: flex;
  height: 80vh;
  position: relative;
}
.fi-customer-settings-preview:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.fi-customer-settings-preview .Ccm-LoginContainer {
  margin-top: 100px;
}

.fi-customer-settings-preview-desktop {
  flex: 9;
  text-align: center;
  display: flex;
}

.fi-customer-settings-preview-desktop-device {
  position: relative;
  flex: 1;
}
.fi-customer-settings-preview-desktop-device img {
  max-height: 100%;
  max-width: 100%;
  position: relative;
}
.fi-customer-settings-preview-desktop-device fi-authenticate-login {
  display: block;
}

.fi-customer-settings-preview-desktop-bg {
  position: absolute;
  background: var(--fi-branded-image-landscape) center center no-repeat;
  background-size: cover;
  display: none;
}
.fi-customer-settings-preview-desktop-bg > fi-authenticate-login {
  transform-origin: top left;
  position: absolute;
  top: 5%;
  left: 50%;
}
.fi-customer-settings-preview-desktop-bg.loaded {
  display: block;
}

.fi-customer-settings-preview-mobile {
  flex: 4;
  display: flex;
}

.fi-customer-settings-preview-mobile-device {
  position: relative;
  flex: 1;
}
.fi-customer-settings-preview-mobile-device img {
  max-height: 100%;
  max-width: 100%;
}
.fi-customer-settings-preview-mobile-device fi-authenticate-login {
  display: block;
}

.fi-customer-settings-preview-mobile-bg,
.fi-customer-settings-preview-mobile-app-bg {
  position: absolute;
  top: 66px;
  right: 44px;
  bottom: 60px;
  left: 47px;
}

/*.fi-customer-settings-preview-mobile-bg {
  background: var(--fi-branded-image-portrait) center center no-repeat;
  background-size: cover;

  > fi-authenticate-login {
    transform-origin: top left;
    position: absolute;
    top: 5%;
    left: 50%;
  }
}*/
.fi-customer-settings-preview-mobile-app-bg {
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./Source/app/appearance/customer-settings/customer-settings-preview-dialog/customer-settings-preview-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,UAAA;AAAR;;AAIA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;AADJ;AAII;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AAFR;AAKI;EACI,iBAAA;AAHR;;AAOA;EACI,OAAA;EACA,kBAAA;EACA,aAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,OAAA;AAJJ;AAMI;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;AAJR;AAOI;EACI,cAAA;AALR;;AASA;EACI,kBAAA;EACA,qEAAA;EACA,sBAAA;EACA,aAAA;AANJ;AAQI;EACI,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AANR;AASI;EACI,cAAA;AAPR;;AAWA;EACI,OAAA;EACA,aAAA;AARJ;;AAWA;EACI,kBAAA;EACA,OAAA;AARJ;AAUI;EACI,gBAAA;EACA,eAAA;AARR;AAWI;EACI,cAAA;AATR;;AAaA;;EAEI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAVJ;;AAaA;;;;;;;;;;EAAA;AAYA;EACI,mBAAA;AAXJ","sourcesContent":[".fi-customer-settings-preview-panel {\r\n    .mat-mdc-dialog-content {\r\n        max-height: 90vh;\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview {\r\n    display: flex;\r\n    height: 80vh;\r\n    position: relative;\r\n\r\n    // overlay to disable user interactions\r\n    &:after {\r\n        content: '';\r\n        display: block;\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n    }\r\n\r\n    .Ccm-LoginContainer {\r\n        margin-top: 100px;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-desktop {\r\n    flex: 9;\r\n    text-align: center;\r\n    display: flex;\r\n}\r\n\r\n.fi-customer-settings-preview-desktop-device {\r\n    position: relative;\r\n    flex: 1;\r\n\r\n    img {\r\n        max-height: 100%;\r\n        max-width: 100%;\r\n        position: relative;\r\n    }\r\n\r\n    fi-authenticate-login {\r\n        display: block;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-desktop-bg {\r\n    position: absolute;\r\n    background: var(--fi-branded-image-landscape) center center no-repeat;\r\n    background-size: cover;\r\n    display: none;\r\n\r\n    > fi-authenticate-login {\r\n        transform-origin: top left;\r\n        position: absolute;\r\n        top: 5%;\r\n        left: 50%;\r\n    }\r\n\r\n    &.loaded {\r\n        display: block;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-mobile {\r\n    flex: 4;\r\n    display: flex;\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-device {\r\n    position: relative;\r\n    flex: 1;\r\n\r\n    img {\r\n        max-height: 100%;\r\n        max-width: 100%;\r\n    }\r\n\r\n    fi-authenticate-login {\r\n        display: block;\r\n    }\r\n}\r\n\r\n.fi-customer-settings-preview-mobile-bg,\r\n.fi-customer-settings-preview-mobile-app-bg {\r\n    position: absolute;\r\n    top: 66px;\r\n    right: 44px;\r\n    bottom: 60px;\r\n    left: 47px;\r\n}\r\n\r\n/*.fi-customer-settings-preview-mobile-bg {\r\n  background: var(--fi-branded-image-portrait) center center no-repeat;\r\n  background-size: cover;\r\n\r\n  > fi-authenticate-login {\r\n    transform-origin: top left;\r\n    position: absolute;\r\n    top: 5%;\r\n    left: 50%;\r\n  }\r\n}*/\r\n\r\n.fi-customer-settings-preview-mobile-app-bg {\r\n    background: #ffffff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
